import {ReactComponent as IconGraph} from '#/components/icons/graph.svg';
import {ReactComponent as IconWallet} from '#/components/icons/ico-wallet.svg';
import {useWalletProvider} from '#/contexts/wallet-provider';
import {PortfolioTab} from '#/navigation/tabs';
import {ExchangeRoute} from '#/routes/exchange/exchange-route';
import {getExchangeRouteWithQueryParams} from '#/routes/exchange/get-exchange-route-with-query-params';
import {DefaultChildren} from '#/utils/utils';
import {FunctionComponent, ReactNode} from 'react';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';

export const WalletInfo: FunctionComponent<DefaultChildren> = () => {
  const {
    accountResult: {isConnected},
  } = useWalletProvider();

  const {t} = useTranslation('translation');

  if (isConnected) {
    return (
      <div className='gap-3 h-full flex items-center whitespace-nowrap'>
        <Link
          to={getExchangeRouteWithQueryParams(ExchangeRoute.PORTFOLIO, {portfolioTabId: PortfolioTab.ASSETS})}
          className='flex items-center hover:opacity-70 bg-graybluedark2 rounded-md'
        >
          <IconSeparatorContentBox>
            {{
              icon: <IconWallet className='w-4 h-4 stroke-black fill-[#21DB6C]' />,
              content: (
                <>
                  <span className='text-gray-300'>{t('appSections.portfolio')}</span>
                </>
              ),
            }}
          </IconSeparatorContentBox>
        </Link>
      </div>
    );
  }

  return (
    <div className='flex items-center hover:opacity-70 bg-graybluedark2 rounded-md'>
      <IconSeparatorContentBox>
        {{
          icon: <IconGraph className='w-4 h-4 stroke-gray-400 fill-transparent' />,
          content: <span className='text-gray-300'>{t('components.header.walletInfo.getStarted')}</span>,
        }}
      </IconSeparatorContentBox>
    </div>
  );
};

const IconSeparatorContentBox: FunctionComponent<{
  children: {
    icon: ReactNode;
    content: ReactNode;
  };
  className?: string;
  hideDivider?: boolean;
}> = ({children, className = '', hideDivider = false}) => {
  return (
    <div
      className={`flex gap-2 py-1 px-2 justify-between items-center h-full rounded border border-gray-500 text-white group relative box-border ${className}`}
    >
      {children.icon}
      {hideDivider && <span className='hidden sm:block w-[1px] h-full bg-gray-500' />}
      <span className='hidden sm:flex-center gap-2'>{children.content}</span>
    </div>
  );
};
